import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton } from '@mui/material';

import SubNavbar from '../components/SubNavbar';
import { ReactComponent as EditIcon } from '../../../assetsNew/icons/edit.svg';
import { groupFlowSetNamePopup } from '../../../sagas/myCreators/regularGroup/groupFlow/actions';

import './_groupsNav.scss';

const GroupsNav = () => {
  const dispatch = useDispatch();
  const { data: { name } } = useSelector(s => s.groupFlow);

  const openNamePopup = () => {
    dispatch(groupFlowSetNamePopup(true));
  };

  return (
    <div className="groupsNav">
      <SubNavbar route={name}>
        {name && <IconButton className="edit-btn" onClick={openNamePopup}><EditIcon /></IconButton>}
      </SubNavbar>
    </div>
  );
};

export default GroupsNav;